var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 639,
    height: 127,
    viewBox: "0 0 639 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.329 48.06L278.319 48.07L244.469 3.75L241.599 0H218.509L266.649 63.01L216.059 126.43H239.409L289.779 63.04L278.329 48.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27 75.32L19.66 0H0V126.43H19V28.53L68.73 97.08H79.8L129.9 28.16V126.43H149.08V0H129.25L74.27 75.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.352 0H183.352V126.43H202.352V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.299 70.27H486.889V53.63H423.299V17.19H496.489V0H404.289V126.43H500.839V109.43H423.299V70.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.109 71.21C624.439 66.88 634.899 55.42 634.899 39.49V35.14C634.899 13.47 618.169 0 591.249 0H526.219V126.43H545.219V75.16H587.419L617.679 126.43H638.839L606.109 71.21ZM545.229 58.7V17.19H590.169C605.559 17.19 615.909 24.69 615.909 35.86V40.39C615.909 49.16 608.329 58.23 591.439 58.7H545.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.051 48.06L324.041 48.07L287.811 0.64L287.321 0H264.221L312.361 63.01L261.781 126.43H285.121L324.001 77.97L361.641 126.43H384.761L335.501 63.04L324.051 48.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.87 34.29C332.49 37.32 332.5 41.59 334.91 44.61L342.5 54.11L384.96 0H361.82L334.87 34.29Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 638.84,
    height: 126.43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.06ea2cae517be21b44ba953e01bce05a.svg";
export { ForwardRef as ReactComponent };